import { GlobalStyles } from "@mui/material";

const GlobalStyle = GlobalStyles`
  html,
  body,
  #root {
    height: 100%;
    overflow-x: hidden;
    font-size: 20px;
  }

  body {
    background: ${(props) => props.theme.palette.background.default};
    margin: 0;
  }

  .MuiCardHeader-action .MuiIconButton-root {
    padding: 4px;
    width: 28px;
    height: 28px;
  }
`;

export default GlobalStyle;
